/**
 * @generated SignedSource<<11868558a883feeae11c12a0ef8f698d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoPageDirectOpencastLinkQuery$variables = {
  eventPassword?: string | null | undefined;
  eventUser?: string | null | undefined;
  id: string;
  listId: string;
};
export type VideoPageDirectOpencastLinkQuery$data = {
  readonly event: {
    readonly " $fragmentSpreads": FragmentRefs<"VideoPageEventData">;
  } | null | undefined;
  readonly playlist: {
    readonly " $fragmentSpreads": FragmentRefs<"PlaylistBlockPlaylistData">;
  } | null | undefined;
  readonly realm: {
    readonly " $fragmentSpreads": FragmentRefs<"NavigationData" | "VideoPageRealmData">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"UserData">;
};
export type VideoPageDirectOpencastLinkQuery = {
  response: VideoPageDirectOpencastLinkQuery$data;
  variables: VideoPageDirectOpencastLinkQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventPassword"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventUser"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "listId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listId"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "dummy",
    "storageKey": null
  }
],
v8 = {
  "kind": "InlineFragment",
  "selections": (v7/*: any*/),
  "type": "NotAllowed",
  "abstractKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creators",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLive",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opencastId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "metadata",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canWrite",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnail",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uri",
  "storageKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    (v10/*: any*/),
    (v13/*: any*/),
    (v12/*: any*/),
    (v14/*: any*/),
    (v11/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Series",
      "kind": "LinkedField",
      "name": "series",
      "plural": false,
      "selections": [
        (v10/*: any*/),
        (v9/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SyncedEventData",
      "kind": "LinkedField",
      "name": "syncedData",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v18/*: any*/),
        (v19/*: any*/),
        (v20/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "audioOnly",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AuthorizedEvent",
  "abstractKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoPageDirectOpencastLinkQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "UserData"
      },
      {
        "alias": "event",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventByOpencastId",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "eventPassword",
                "variableName": "eventPassword"
              },
              {
                "kind": "Variable",
                "name": "eventUser",
                "variableName": "eventUser"
              }
            ],
            "kind": "FragmentSpread",
            "name": "VideoPageEventData"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "realm",
        "args": null,
        "concreteType": "Realm",
        "kind": "LinkedField",
        "name": "rootRealm",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "VideoPageRealmData"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NavigationData"
          }
        ],
        "storageKey": null
      },
      {
        "alias": "playlist",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "playlistById",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlaylistBlockPlaylistData"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "VideoPageDirectOpencastLinkQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRealmHandle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUpload",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseStudio",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canUseEditor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateUserRealm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreateSeries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canCreatePlaylists",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isTobiraAdmin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "canFindUnlisted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roles",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userRole",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "event",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "eventByOpencastId",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isEvent"
          },
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPassword",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SyncedEventData",
                "kind": "LinkedField",
                "name": "syncedData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "updated",
                    "storageKey": null
                  },
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "password",
                    "variableName": "eventPassword"
                  },
                  {
                    "kind": "Variable",
                    "name": "user",
                    "variableName": "eventUser"
                  }
                ],
                "concreteType": "AuthorizedEventData",
                "kind": "LinkedField",
                "name": "authorizedData",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Track",
                    "kind": "LinkedField",
                    "name": "tracks",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flavor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "mimetype",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "resolution",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isMaster",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Caption",
                    "kind": "LinkedField",
                    "name": "captions",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lang",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Segment",
                    "kind": "LinkedField",
                    "name": "segments",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      (v19/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Series",
                "kind": "LinkedField",
                "name": "series",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v15/*: any*/),
                  (v10/*: any*/),
                  (v13/*: any*/),
                  (v11/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "state",
                    "storageKey": null
                  },
                  (v16/*: any*/),
                  (v17/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "entries",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v23/*: any*/),
                      (v8/*: any*/),
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "AuthorizedEvent",
            "abstractKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "realm",
        "args": null,
        "concreteType": "Realm",
        "kind": "LinkedField",
        "name": "rootRealm",
        "plural": false,
        "selections": [
          (v25/*: any*/),
          (v26/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMainRoot",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Realm",
            "kind": "LinkedField",
            "name": "ancestors",
            "plural": true,
            "selections": [
              (v25/*: any*/),
              (v26/*: any*/),
              (v9/*: any*/)
            ],
            "storageKey": null
          },
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RealmNav",
            "kind": "LinkedField",
            "name": "nav",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RealmNavItem",
                "kind": "LinkedField",
                "name": "header",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RealmNavItem",
                "kind": "LinkedField",
                "name": "list",
                "plural": true,
                "selections": [
                  (v25/*: any*/),
                  (v26/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasChildren",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "listOrder",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "playlist",
        "args": (v5/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "playlistById",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isPlaylist"
          },
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "creator",
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "entries",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v23/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v7/*: any*/),
                    "type": "Missing",
                    "abstractKey": null
                  },
                  (v8/*: any*/),
                  (v24/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "AuthorizedPlaylist",
            "abstractKey": null
          },
          (v24/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d3113d5919dba10c48808142183565a",
    "id": null,
    "metadata": {},
    "name": "VideoPageDirectOpencastLinkQuery",
    "operationKind": "query",
    "text": "query VideoPageDirectOpencastLinkQuery(\n  $id: String!\n  $listId: ID!\n  $eventUser: String\n  $eventPassword: String\n) {\n  ...UserData\n  event: eventByOpencastId(id: $id) {\n    __typename\n    ...VideoPageEventData_3J3oez\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  realm: rootRealm {\n    ...VideoPageRealmData\n    ...NavigationData\n    id\n  }\n  playlist: playlistById(id: $listId) {\n    __typename\n    ...PlaylistBlockPlaylistData\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment NavigationData on Realm {\n  id\n  name\n  path\n  nav {\n    header {\n      name\n      path\n    }\n    list {\n      name\n      path\n      hasChildren\n    }\n    listOrder\n  }\n}\n\nfragment PlaylistBlockPlaylistData on Playlist {\n  __isPlaylist: __typename\n  __typename\n  ... on NotAllowed {\n    dummy\n  }\n  ... on AuthorizedPlaylist {\n    id\n    title\n    description\n    creator\n    canWrite\n    entries {\n      __typename\n      ... on AuthorizedEvent {\n        id\n        ...VideoListEventData\n      }\n      ... on Missing {\n        dummy\n      }\n      ... on NotAllowed {\n        dummy\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment SeriesBlockSeriesData on Series {\n  id\n  title\n  created\n  description\n  state\n  metadata\n  canWrite\n  entries {\n    __typename\n    ... on AuthorizedEvent {\n      id\n      ...VideoListEventData\n    }\n    ... on NotAllowed {\n      dummy\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment UserData on Query {\n  currentUser {\n    username\n    displayName\n    userRealmHandle\n    canUpload\n    canUseStudio\n    canUseEditor\n    canCreateUserRealm\n    canCreateSeries\n    canCreatePlaylists\n    isTobiraAdmin\n    canFindUnlisted\n    roles\n    userRole\n  }\n}\n\nfragment VideoListEventData on AuthorizedEvent {\n  id\n  title\n  created\n  creators\n  isLive\n  description\n  series {\n    title\n    id\n  }\n  syncedData {\n    thumbnail\n    duration\n    startTime\n    endTime\n    audioOnly\n  }\n}\n\nfragment VideoPageAuthorizedData_3J3oez on AuthorizedEvent {\n  authorizedData(user: $eventUser, password: $eventPassword) {\n    tracks {\n      uri\n      flavor\n      mimetype\n      resolution\n      isMaster\n    }\n    captions {\n      uri\n      lang\n    }\n    segments {\n      uri\n      startTime\n    }\n  }\n  id\n}\n\nfragment VideoPageEventData_3J3oez on Event {\n  __isEvent: __typename\n  __typename\n  ... on NotAllowed {\n    dummy\n  }\n  ... on AuthorizedEvent {\n    id\n    title\n    description\n    creators\n    created\n    isLive\n    opencastId\n    metadata\n    canWrite\n    hasPassword\n    syncedData {\n      updated\n      duration\n      startTime\n      endTime\n      thumbnail\n    }\n    ...VideoPageAuthorizedData_3J3oez\n    series {\n      id\n      opencastId\n      title\n      ...SeriesBlockSeriesData\n    }\n  }\n}\n\nfragment VideoPageRealmData on Realm {\n  name\n  path\n  isMainRoot\n  ancestors {\n    name\n    path\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3580867ae51f406d46b76dd089014771";

export default node;
